<template>
	<div class="index">
		<div class="bxzy_banner" style="width: 100%;height: auto;">
			<img style="width: 100%;height: 100%;" src="../../assets/zhuozi/tree_banner.png">
		</div>
		<div class="home_wrap">
			<div class="schoolResouce_bxzy">
				<div class="news_title">
					<div class="news_title_left">
						<div @click="changeType(1)" class="news_title_left_text"
							:style="{ color: true ? '#000000' : '#999999', fontWeight: true ? '800' : '400' }">课程链接
						</div>
					</div>
					<div class="right_back" @click="$router.go(-1)">
						<div class="right_back_icon"><img src="../../assets/xiangning/newsCenter/back.png" alt=""></div>
						<div>返回</div>
					</div>
				</div>
				<div class="schoolResouce_content">
					<div class="schoolResouce_content_item" @click="goSpeaial(16, item.id)" v-for="item in dataList">
						<a :href="item.url" target="_blank" style="text-decoration: none;">
							<div class="schoolResouce_pic">
								<img :src="item.img" alt="">
							</div>
							<div class="schoolResouce_title">
								{{ item.title }}
							</div>
						</a>
					</div>
				</div>
			</div>

		</div>

	</div>
</template>
<script>

import { bxzy } from '@/axios';
import Title from '@/components/title.vue'
import { Message } from 'element-ui'
export default {
	data() {
		return {
			dataList: []

		}
	},
	components: { Title, },
	methods: {

		getdataList() {
			let that = this
			bxzy.treelist().then(res => {
				if (res.code == 200) {
					console.log(res);
					that.dataList = res.data
				}
			})
		},

	},
	mounted() {
		this.getdataList()


	},
	created() {
		this.$emit("highLight", 10, "", "", "");


	}
}
</script>

<style lang="scss" >
@import '@/common/index.scss';

.index {
	width: 100%;

	div {
		box-sizing: border-box;
	}

	.bxzy_banner {
		position: relative;
		width: 100%;
		min-width: 1200px;
		height: 200px;
		background-size: 100% 100%;
		display: flex;
		justify-content: center;
		align-items: center;

	}

	//  新闻中心
	.home_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;

		/* 标题部分样式 */
		.news_title {
			height: 40px;
			width: 100%;

			margin: 20px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-left: 10px;
			background: #F7F7F7;
		}

		.news_title_left {
			// width: 300px;
			height: 22px;
			border-left: 4px solid #EE632B;
			// padding-left: 20px;
			display: flex;
			justify-content: space-between;

		}

		.news_title_left_text {
			height: 22px;
			// width: 80px;
			padding: 0 20px;
			font-family: PingFangSC-Regular;
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 0.1em;
			color: #999999;
		}

		.right_back {
			display: flex;
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: 0em;
			color: #666666;
			margin-right: 10px;
			cursor: pointer;
		}

		.right_back:hover {
			font-weight: 800;
			color: #EE632B;
		}

		.right_back_icon {
			height: 10px;
			width: 12px;
			margin-right: 5px;
		}

		.right_back_icon img {
			height: 100%;
			width: 100%;
		}




		// 本校资源
		.schoolResouce_bxzy {
			width: 100%;
			margin-top: 30px;
			margin-bottom: 30px;

			.schoolResouce_bxzy_top {
				width: 100%;
				height: 420px;
				display: flex;
				justify-content: space-between;
				margin: 20px auto;

				.schoolResouce_bxzy_top_left {
					width: 590px;
					height: 100%;
					border-radius: 8px;
					overflow: hidden;
					border: 1px solid #ECEEF4;

					.bxzy_top_img {
						width: 100%;
						height: 380px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.bxzy_bottom_title {
						width: 100%;
						height: 42px;
						box-sizing: border-box;
						padding: 0 10px;
						line-height: 40px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						font-family: PingFangSC-Medium;
						font-size: 14px;
						font-weight: 800;
						line-height: 32px;
						letter-spacing: 0em;
						color: #000000;
					}
				}

				.schoolResouce_bxzy_top_right {
					width: 590px;
					display: flex;
					flex-wrap: wrap;
					gap: 20px;
				}
			}

			.schoolResouce_content {
				width: 100%;
				// height: 160px;
				margin-top: 16px;
				display: flex;
				flex-wrap: wrap;
				gap: 20px;
				margin-bottom: 20px;


				.schoolResouce_content_item:nth-child(4n) {
					margin-right: 0;
				}
			}

			.schoolResouce_content_item {
				width: 285px;
				height: 200px;
				// margin-right: 20px;
				border-radius: 8px;
				border: 1px solid #ECEEF4;
				overflow: hidden;

				.schoolResouce_pic {
					width: 100%;
					height: 160px;

					img {
						width: 100%;
						height: 100%;

					}
				}

				.schoolResouce_title {
					width: 100%;
					height: 32px;
					box-sizing: border-box;
					padding: 0 10px;
					line-height: 32px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					font-family: PingFangSC-Medium;
					font-size: 14px;
					font-weight: 800;
					line-height: 32px;
					letter-spacing: 0em;
					color: #000000;
				}
			}


		}


	}

}
</style>
